export default "__VITE_ASSET__Cq3XYD10__"